import YookassaService from '../../services/YookassaService';
import yookassaUseCase from './yookassaUseCase';

const yookassaFactory = yookassaUseCase({
  YookassaService: YookassaService(),
});

export default yookassaFactory;
